import { lazy } from "react";
import { getRoute } from "util/react";

export const SelectCategoryRoute = getRoute(
  { fullPath: "/:locale?/create-order/select-category" },
  "create-order/select-category",
  lazy(() => import("./selectCategory")),
  null,
);

export const PaymentRoute = getRoute(
  { fullPath: "/:locale?/create-order/payment/:id" },
  "create-order/payment/:id",
  lazy(() => import("./payment")),
  null,
);

export const SelectRouteRoute = getRoute(
  { fullPath: "/:locale?/create-order/select-route" },
  "create-order/select-route",
  lazy(() => import("./selectRoute")),
  null,
);

export const OrderOverviewRoute = getRoute(
  { fullPath: "/:locale?/create-order/overview" },
  "create-order/overview",
  lazy(() => import("./overview")),
  null,
);

export const DamageReportRoute = getRoute(
  { fullPath: "/:locale?/create-order/damage-report/:id" },
  "create-order/damage-report/:id",
  lazy(() => import("./damageReport")),
  null,
);

export const CargoInfoRoute = getRoute(
  { fullPath: "/:locale?/create-order/cargo-info" },
  "create-order/cargo-info",
  lazy(() => import("./cargoInformation")),
  null,
);

const CreateOrderRoute = (
  <>
    {SelectCategoryRoute}
    {SelectRouteRoute}
    {OrderOverviewRoute}
    {DamageReportRoute}
    {CargoInfoRoute}
    {PaymentRoute}
  </>
);

export default CreateOrderRoute;
